import styled from 'styled-components';

export default styled.a`
  ${props => props}
  border-radius: ${props => props.theme.old.rounded.md};
  width: ${props => props.width};
  max-width: 90%;
  min-height: 160px;
  display: ${props => props.display || 'flex'};
  align-items: ${props => props.align || 'center'};
  justify-content: ${props => props.justify || 'center'};
  margin: ${props => props.margin || '0 auto'};
  transition: ${props => props.theme.old.transition.default};
  box-shadow: ${props => props.theme.old.shadow.black};
  gap: ${props => props.gap || "48px"};
  padding: 48px;
`;